<template>
<main class="main" v-loading="loading">
	<div class="price_banner pc">
		<div class="w1200">
			<img class="pic1" src="../assets/news/banner_news.png">
			<h1>无纸化 轻量化 便捷化 </h1>
            <!-- <h5>构建资产智能管理体系<br>巡更巡查智慧应用</h5> -->
		</div>
		<img class="pic2" src="../assets/price/banner_river.png">
		
	</div>
	<div class="w1200">
        <!-- <h1 class="title"><img src="../assets/zhineng.png">云资产新闻</h1> -->
        <!-- <div class="line"></div> -->
		<div class="news-header">
	        <ol>
	            <li @click="getNews('-1')" :class="{active:type=='-1'}">综合</li>
	            <li @click="getNews(0)" :class="{active:type==0}">行业资讯</li>
	            <li @click="getNews(1)" :class="{active:type==1}">业务动态</li>
	            <li @click="getNews(2)" :class="{active:type==2}">企业动态</li>
	        </ol>
	    </div>
		<div class="pageNews">
		    <ul class="clear">
		        <li class="wow fadeInUp" v-for="item in newsList" :key="item">
                    <router-link :to="{ path: '/newsDetail', query: { id: item.id}}">
    		            <div class="img"><img :src="item.titleImg" title="" alt=""></div>
    		            <div class="cont">
    		                <div class="time">{{item.createTime}}</div>
    		                <div class="title">{{item.title}}</div>
    		                <div class="summary" v-if='item.remark'>{{item.remark}}</div>
                            <div class="summary" v-else>...</div>
    		            </div>
    		        </router-link>
                </li>
		    </ul>
		</div>
	</div>
    <div class="w1200" v-if='!loadTxt'><el-button size="small" @click="load" style="display:block;margin:30px auto">加载更多</el-button></div>
    <div class="w1200"><div style="display:block;margin:30px auto;color:#999;text-align: center;">{{loadTxt}}</div></div>
    
<!--   	<div class="w1000">
  		<div class="pano-list">
            <div class="pano-list-item">
                <div class="pano-list-img">
                    <a href="newsDetail.jsp" class="pano-list-imga">
                        <img src="">
                    </a>
                </div>
                <div class="pano-list-info">
                    <div class="pano-list-title">
                        <div class="pano-list-t1">
                            <a href="#">产权单位——苏州市相城第三实验中学</a>
                        </div>
                        <div class="pano-list-time">2019-08-29</div>
                    </div>
                    <div class="pano-list-remark">
                        <a href="newsDetail.jsp">云资产与苏州市相城第三实验中学成功签订合作协议。</a>
                    </div>
                    <div class="pano-list-author">
                        <div class="pano-list-user">
                            <a href="" class="pano-list-headimg">
                                <img src="">
                            </a>
                            <a href=""><span class="pano-list-nickname">徐春伟</span></a>
                        </div>
                        <div class="pano-list-view">
                            <span><em class="fa fa-eye"></em> 浏览量 2.59万</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  	</div> -->
</main>
		
</template>
<script>
export default {
  name: 'news',
  data () {
    return {
      loading:true, 
      loadTxt:'',    
      page:1,
      limit:6,
      count:'',
      type:'-1',
      newsList:[],
    }
  },
  created(){
    var that=this;
    var obj={}
    obj.page=that.page
    obj.limit=that.limit
    obj.type=''
    
    $.ajax({
        url : '/api/news/queryNewsList',
        type : 'POST',
        dataType : 'json',
        data:JSON.stringify(obj),
        headers:{
            'Content-Type': 'application/JSON',
            'apiFlag':"1"
        },
        success : function(data) {
            that.newsList=data.data;
            that.loading=false
            if(data.data.length<6){
                that.loadTxt="没有更多了"
            }
        },
        error : function(msg) {
        }
    });
  },
  methods: {
    getNews(obj){
        this.loading=true
        this.loadTxt=""
        this.type=obj
        this.page=1
        var that=this;
        that.loading=true
        var queryNew={}
        queryNew.page=that.page,
        queryNew.limit=that.limit,
        queryNew.type=obj
        if(queryNew.type=='-1'){
            queryNew.type=''
        }
        $.ajax({
            url : '/api/news/queryNewsList',
            type : 'POST',
            dataType : 'json',
            data:JSON.stringify(queryNew),
            async: false,
            headers:{
                'Content-Type': 'application/JSON',
                'apiFlag':"1"
            },
            success : function(data) {
                that.loading=false
                if(data.data.length<6){
                    that.loadTxt="没有更多了"
                }else if(data.data==null||data.data==''){
                    that.loadTxt="暂无信息"
                }
                that.newsList=data.data;
            },
            error : function(msg) {
            }
        });
    },
    load () {
        var that=this;
        that.loading=true
        that.page++
        var obj={}
        obj.page=that.page
        obj.limit=that.limit
        obj.type=that.type
        if(obj.type=='-1'){
            obj.type=''
        }
        $.ajax({
            url : '/api/news/queryNewsList',
            type : 'POST',
            dataType : 'json',
            data:JSON.stringify(obj),
            async: false,
            headers:{
                'Content-Type': 'application/JSON',
                'apiFlag':"1"
            },
            success : function(data) {
                if(data.data!=''){
                    if(data.data.length<6){
                        that.loadTxt="没有更多了"
                    }
                    for(var i=0;i<data.data.length;i++){
                        that.newsList.push(data.data[i])
                    }
                }else{
                    that.page--
                    that.loadTxt="没有更多了"
                }
                that.loading=false
            },
            error : function(msg) {
            }
        });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/news.vue